module.exports = __webpack_public_path__ + "img/intro-medicine.c776eb5a.png";